import React, { ReactElement } from 'react';
import { Button } from '@dotcom/crown-ui';
import { DialogCtaProps } from '../consumer-review-dialog-types';
import styles from '../consumer-review-dialog.module.scss';

export const BackToPreviewButton = ({ click, buttonText }: DialogCtaProps): ReactElement => (
  <Button
    onClick={click}
    variant="secondary"
    testId="back-to-preview-button"
    className={styles['button-text-transform']}
  >
    {buttonText}
  </Button>
);
